const pvz_selected = (state) => {
    return state.pvz_selected
}
const pvz_obj_selected = (state) => {
    return state.pvz_obj_selected
}
const deliv_type_group = (state) => {
    return state.deliv_type_group
}
const deliv_type_id = (state) => {
    return state.deliv_type_id
}
const deliv_region_id = (state) => {
    return state.deliv_region_id
}
const deliv_city_id = (state) => {
    return state.deliv_city_id
}
const pay_type = (state) => {
    return state.pay_type
}
const pvzs = (state) => {
    return state.pvzs
}
const coordinates = (state) => {
    return state.coordinates;
}
const require_address = (state) => {
    return state.require_address;
}
const require_passport = (state) => {
    return state.require_passport;
}

export default {
    pvz_selected,
    pvz_obj_selected,
    deliv_type_group,
    deliv_type_id,
    deliv_region_id,
    deliv_city_id,
    pay_type,
    pvzs,
    coordinates,
    require_address,
    require_passport
}
